module.exports = __webpack_public_path__ + "img/bologna.7e7defc2.png";